export function dateIsLessThan(date, time, platformTime = new Date()) {
  const dateTime = date + " " + time;
  if (new Date(dateTime) < platformTime) return true;
  return false;
}
